import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function LaborProgressForm() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    patientId: '',
    startTime: '',
    dilation: '',
    effacement: '',
    station: '',
    contractions: '',
    heartRate: '',
    painManagement: '',
    deliveryType: '',
    APIType: 'laborProgress'
  });

  const [errors, setErrors] = useState({
    patientId: false,
    startTime: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      patientId: !formData.patientId,
      startTime: !formData.startTime
    };
    
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) return;

    try {
      await handleAPICall(formData);
      // Reset form after submission
      setFormData({
        patientId: '',
        startTime: '',
        dilation: '',
        effacement: '',
        station: '',
        contractions: '',
        heartRate: '',
        painManagement: '',
        deliveryType: '',
        APIType: 'laborProgress'
      });
    } catch (error) {
      console.error('Labor progress submission failed:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: false }));
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className="p-5 bg-white rounded-4 shadow-lg mt-5"
      style={{ maxWidth: '', margin: '0 auto' }}
    >
      <h2 className="mb-2 text-primary text-center fw-bold">Labor Progress Tracking</h2>

      <div className="row g-4 mb-2">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Patient *</label>
            <select
              name="patientId"
              value={formData.patientId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.patientId ? 'is-invalid' : ''}`}
            >
              <option value="">Select Patient</option>
              <option value="1">Patient 1</option>
              <option value="2">Patient 2</option>
            </select>
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Labor Start Time *</label>
            <input
              type="datetime-local"
              name="startTime"
              value={formData.startTime}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.startTime ? 'is-invalid' : ''}`}
            />
          </div>
        </div>
      </div>

      <div className="row g-4 mb-2">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Cervical Dilation (cm)</label>
            <input
              type="number"
              name="dilation"
              min="0"
              max="10"
              step="0.5"
              value={formData.dilation}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Effacement (%)</label>
            <input
              type="number"
              name="effacement"
              min="0"
              max="100"
              value={formData.effacement}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Station</label>
            <input
              type="number"
              name="station"
              min="-5"
              max="5"
              value={formData.station}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
            />
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Contractions (/10min)</label>
            <input
              type="number"
              name="contractions"
              min="0"
              value={formData.contractions}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
            />
          </div>
        </div>
      </div>

      <div className="row g-4 mb-2">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Fetal Heart Rate</label>
            <input
              type="number"
              name="heartRate"
              value={formData.heartRate}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2 px-0"
              placeholder="BPM"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Pain Management</label>
            <select
              name="painManagement"
              value={formData.painManagement}
              onChange={handleChange}
              className="form-select border-bottom border-light py-2 w-100"
            >
              <option value="">Select Method</option>
              <option value="epidural">Epidural</option>
              <option value="nitrous">Nitrous Oxide</option>
              <option value="iv">IV Pain Relief</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-12">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Delivery Type</label>
            <select
              name="deliveryType"
              value={formData.deliveryType}
              onChange={handleChange}
              className="form-select border-bottom border-light py-2 w-100"
            >
              <option value="">Select Delivery Type</option>
              <option value="vaginal">Vaginal</option>
              <option value="cesarean">Cesarean</option>
            </select>
          </div>
        </div>
      </div>

      <div className="d-grid mt-5">
        <button 
          type="submit"
          className="btn btn-primary btn-lg py-3 fw-bold hover-effect w-100"
          disabled={!formData.patientId || !formData.startTime}
        >
          Save Labor Progress
        </button>
      </div>
    </form>
  );
}

export default LaborProgressForm;